<a routerLink="/detail/{{ streapp.id }}" class="overview-card-link">
  <mat-card
    class="widget widget-thumbnail overview-widget"
    [title]="streapp.title"
    >
    <div class="card-info">
      @if (!isAdultOrLowImpact()) {
        <div class="video-blur">
          <span>{{ "page.adultVideo" | translate }}</span>
        </div>
      }
      @if (!streapp.thumbnail) {
        <div class="video-blur">
          <span>{{ "page.processing" | translate }}</span>
        </div>
      }
      <div class="video-preview">
        <img
          [src]="thumbnail"
          [alt]="streapp.title"
          onerror="this.onerror = null; this.src = './assets/images/fallback-thumb.png';"
          />
        </div>
        <div class="bottom">
          <div class="video-attributes">
            <div class="toptext">
              <h1 class="ellipsified">{{ streapp.title }}</h1>
              <!-- Images & Video's -->
              @if (streapp.amountOfVideos && streapp.amountOfImages) {
                <div class="mediaItems-sum">
                  {{ streapp.amountOfVideos }} video('s) |
                  {{ streapp.amountOfImages }} foto('s)
                </div>
              }
              <!-- Only Video's -->
              @if (streapp.amountOfVideos && streapp.amountOfImages === 0) {
                <div class="mediaItems-sum">
                  {{ streapp.amountOfVideos }} video('s)
                </div>
              }
              <!-- Only Images -->
              @if (streapp.amountOfVideos === 0 && streapp.amountOfImages) {
                <div class="mediaItems-sum">
                  {{ streapp.amountOfImages }} foto('s)
                </div>
              }
            </div>
            <div class="category-text">
              <mat-icon>category</mat-icon> {{ streapp.subcategory }}
              {{ streapp.subcategory ? "" : "" }}
            </div>
            <div class="datetime ellipsified">
              <mat-icon>calendar_today</mat-icon>
              {{ streapp.created | date : "dd MMMM yyyy - HH:mm" }}
            </div>
            <div class="location ellipsified ellipsified-2">
              <mat-icon>location_on</mat-icon> {{ streapp.location.locationStreet }},
              {{ streapp.location.locationCity }}
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </a>
